// PluginContract_HeadingNode.ts
export const HeadingNodeContract = {
  pluginName: 'HeadingPlugin',
  nodeTypes: ['HeadingNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('HeadingNode');
    console.log('🔌 [HeadingPlugin] Registered HeadingNode');
  },
};